import {
  GET_ADMIN_SCHEDULED_REPORTS,
  GET_ADMIN_SCHEDULED_REPORTS_SUCCESS,
  GET_ADMIN_SCHEDULED_REPORTS_ERROR,
  CREATE_ADMIN_SCHEDULED_REPORTS,
  CREATE_ADMIN_SCHEDULED_REPORTS_SUCCESS,
  CREATE_ADMIN_SCHEDULED_REPORTS_ERROR,
  UPDATE_ADMIN_SCHEDULED_REPORTS,
  UPDATE_ADMIN_SCHEDULED_REPORTS_SUCCESS,
  UPDATE_ADMIN_SCHEDULED_REPORTS_ERROR,
  DELETE_ADMIN_SCHEDULED_REPORTS,
  DELETE_ADMIN_SCHEDULED_REPORTS_SUCCESS,
  DELETE_ADMIN_SCHEDULED_REPORTS_ERROR,
  RESET_LAST_ADMIN_SCHEDULED_REPORTS_ACTION,
  GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID,
  GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID_SUCCESS,
  GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID_ERROR,
  REDIRECT_TO_ADMIN_DOWNLOAD_URL,
  REDIRECT_TO_ADMIN_DOWNLOAD_URL_SUCCESS,
  REDIRECT_TO_ADMIN_DOWNLOAD_URL_ERROR
} from "./actionTypes"

export const getAdminScheduledReports = () => {
  return {
    type: GET_ADMIN_SCHEDULED_REPORTS,
  }
}

export const getAdminScheduledReportsSuccess = admin_scheduled_reports => {
  return {
    type: GET_ADMIN_SCHEDULED_REPORTS_SUCCESS,
    payload: admin_scheduled_reports,
  }
}

export const getAdminScheduledReportsError = error => {
  return {
    type: GET_ADMIN_SCHEDULED_REPORTS_ERROR,
    payload: error,
  }
}

export const createAdminScheduledReports = payload => {
  return {
    type: CREATE_ADMIN_SCHEDULED_REPORTS,
    payload: payload
  }
}

export const createAdminScheduledReportsSuccess = admin_scheduled_reports => {
  return {
    type: CREATE_ADMIN_SCHEDULED_REPORTS_SUCCESS,
    payload: admin_scheduled_reports,
  }
}

export const createAdminScheduledReportsError = error => {
  return {
    type: CREATE_ADMIN_SCHEDULED_REPORTS_ERROR,
    payload: error,
  }
}

export const updateAdminScheduledReports = payload => {
  return {
    type: UPDATE_ADMIN_SCHEDULED_REPORTS,
    payload: payload
  }
}

export const updateAdminScheduledReportsSuccess = admin_scheduled_reports => {
  return {
    type: UPDATE_ADMIN_SCHEDULED_REPORTS_SUCCESS,
    payload: admin_scheduled_reports,
  }
}

export const updateAdminScheduledReportsError = error => {
  return {
    type: UPDATE_ADMIN_SCHEDULED_REPORTS_ERROR,
    payload: error,
  }
}

export const deleteAdminScheduledReports = payload => {
  return {
    type: DELETE_ADMIN_SCHEDULED_REPORTS,
    payload: payload
  }
}

export const deleteAdminScheduledReportsSuccess = admin_scheduled_reports => {
  return {
    type: DELETE_ADMIN_SCHEDULED_REPORTS_SUCCESS,
    payload: admin_scheduled_reports,
  }
}

export const deleteAdminScheduledReportsError = error => {
  return {
    type: DELETE_ADMIN_SCHEDULED_REPORTS_ERROR,
    payload: error,
  }
}

export const getAdminScheduledReportLogsById = (payload, admin_scheduled_report_id) => {
  return {
    type: GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID,
    payload: payload,
    admin_scheduled_report_id: admin_scheduled_report_id
  }
}

export const getAdminScheduledReportLogsByIdSuccess = (admin_scheduled_report_logs, admin_scheduled_report_id) => {
  return {
    type: GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID_SUCCESS,
    payload: admin_scheduled_report_logs,
    admin_scheduled_report_id: admin_scheduled_report_id
  }
}

export const getAdminScheduledReportLogsByIdError = (error) => {
  return {
    type: GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID_ERROR,
    payload: error,
  }
}

export const resetLastAdminScheduledReportsAction = (error) => {
  return {
    type: RESET_LAST_ADMIN_SCHEDULED_REPORTS_ACTION,
    payload: error
  }
}

export const redirectToAdminDownloadUrl = (admin_scheduled_report_upload_id) => {
  return {
    type: REDIRECT_TO_ADMIN_DOWNLOAD_URL,
    payload: admin_scheduled_report_upload_id
  }
}

export const redirectToAdminDownloadUrlSuccess = (action) => {
  return {
    type: REDIRECT_TO_ADMIN_DOWNLOAD_URL_SUCCESS,
    payload: action
  }
}

export const redirectToAdminDownloadUrlError = (error) => {
  return {
    type: REDIRECT_TO_ADMIN_DOWNLOAD_URL_ERROR,
    payload: error
  }
}
